import { Directive, Input, HostBinding } from '@angular/core';

/**
 * Applies Bazis color utility classes to the host element.
 *
 * Inputs:
 * - `color: string` — Color name appended to `bazis-color-{color}`.
 *
 * Example:
 * ```html
 * <span color="primary">Primary text</span>
 * ```
 */
@Directive({
    selector: '[color]',
    standalone: true,
})
export class ColorDirective {
    constructor() {}

    /**
     * Color name used to form utility class `bazis-color-{color}`.
     */
    @Input() color: string;

    /**
     * Applies color utility classes to the host.
     */
    @HostBinding('class') get getColorClass() {
        return this.color
            ? {
                  'bazis-color': true,
                  [`bazis-color-${this.color}`]: true,
              }
            : null;
    }
}
